import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { EntryFieldDTO, IEntryFieldDTO } from './entry.field.dto';

export interface IEntryOptionDTO extends IBaseEntityDTO {
  name: string;
  order: number;
  field: IEntryFieldDTO;
}

export class EntryOptionDTO extends BaseEntityDTO implements IEntryOptionDTO {
  name: string;
  order: number;
  field: IEntryFieldDTO;
  constructor(data?: Partial<IEntryOptionDTO>) {
    super();
    this.name = data?.name ?? '';
    this.order = data?.order ?? 0;
    // Initialize field with an empty EntryFieldDTO if not provided
    this.field = data?.field ? new EntryFieldDTO(data.field) : new EntryFieldDTO();
  }
}
